// extracted by mini-css-extract-plugin
export default {"button":"CartBtn_button__ZfdM0","active":"CartBtn_active__kbI6U","total":"CartBtn_total__y5B8+"};